import PropTypes from 'prop-types'

import Chapter from './index'

const ChapterList = ({ chapters }) => (
  <div className='chapters-wrap p-0 d-flex flex-column w-100'>
    {chapters.map(({ id, title }) => <Chapter key={id} {...{ id, title }} />)}
  </div>
)

export default ChapterList

ChapterList.propTypes = {
  chapters: PropTypes.array.isRequired
}
